import { Field, Area, ImagePicker } from "./fields";

export const ProyectosTab = ({ draft, setDraft }) => {
  const update = (i, patch) => {
    const projects = draft.projects.map((p, j) => (j === i ? { ...p, ...patch } : p));
    setDraft({ ...draft, projects });
  };
  return (
    <div className="space-y-6">
      {(draft.projects || []).map((p, i) => (
        <div key={p.id} className="rounded-xl border border-neutral-200 p-4 space-y-4">
          <Field label="Nombre" testId={`proyecto-titulo-${i}`} value={p.title} onChange={(v) => update(i, { title: v })} />
          <Area label="Descripción" testId={`proyecto-descripcion-${i}`} rows={3} value={p.description}
            onChange={(v) => update(i, { description: v })} />
          <Field label="Enlace (vacío = sin botón)" testId={`proyecto-enlace-${i}`} value={p.link || ""}
            placeholder="https://..." onChange={(v) => update(i, { link: v.trim() || null })} />
          <Field label="Texto del botón" testId={`proyecto-boton-${i}`} value={p.linkLabel || ""}
            placeholder="Visitar sitio" onChange={(v) => update(i, { linkLabel: v.trim() || null })} />
          <ImagePicker label="Logo" testId={`proyecto-logo-${i}`} allowRemove value={p.logo}
            onChange={(v) => update(i, { logo: v })} />
        </div>
      ))}
    </div>
  );
};
